import { render, staticRenderFns } from "./SectionEditorToolbar__IconSelector.vue?vue&type=template&id=40af7f29"
import script from "./SectionEditorToolbar__IconSelector.vue?vue&type=script&lang=ts"
export * from "./SectionEditorToolbar__IconSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports